import { useEffect, useState } from 'react';
import { categories } from '../types/category';
import { CategoryCard } from '../components/CategoryCard';
import { pb } from '../lib/pocketbase';

export function Overview() {
  const [totalRecords, setTotalRecords] = useState(0);
  const [recordsByCategory, setRecordsByCategory] = useState<Record<string, number>>({});

  useEffect(() => {
    async function fetchData() {
      try {
        // Get total records count
        const totalList = await pb.collection('facts').getList(1, 1, {
          $cancelKey: 'total-records',
        });
        console.log('Total records response:', totalList);
        setTotalRecords(totalList.totalItems);

        // First, let's get a sample record to see how categories are stored
        const sampleRecord = await pb.collection('facts').getList(1, 1);
        console.log('Sample record:', sampleRecord.items[0]);

        // Get records count for each category
        const categoryPromises = categories.map(async (category) => {
          console.log('Fetching category:', category.id, category.title);
          const list = await pb.collection('facts').getList(1, 1, {
            filter: `categoryId="${category.id}"`,
            $cancelKey: `category-${category.id}`,
          });
          console.log('Category response:', category.id, list);
          return { id: category.id, count: list.totalItems };
        });

        const categoryResults = await Promise.all(categoryPromises);
        console.log('All category results:', categoryResults);
        
        const categoryCountMap = categoryResults.reduce((acc, { id, count }) => {
          acc[id] = count;
          return acc;
        }, {} as Record<string, number>);

        console.log('Final category count map:', categoryCountMap);
        setRecordsByCategory(categoryCountMap);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();

    // Cleanup function to cancel any pending requests
    return () => {
      pb.cancelAllRequests();
    };
  }, []);

  return (
    <div className="space-y-8">
      <section className="bg-[#282828] rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-4">All Records</h2>
        {totalRecords > 0 ? (
          <p className="text-white text-2xl">{totalRecords} records found</p>
        ) : (
          <p className="text-gray-400">No records found</p>
        )}
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-4">Records by Category</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
          {categories.map((category) => {
            const count = recordsByCategory[category.id] || 0;
            console.log('Rendering category:', category.id, 'with count:', count);
            return (
              <CategoryCard 
                key={category.id} 
                category={category} 
                recordCount={count}
              />
            );
          })}
        </div>
      </section>
    </div>
  );
}